import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { organizationApi } from '@/api/services/organization.api';
import { setAccessToken } from '@/api/token';
import type { ICreateOrganizationDto } from '../interfaces/organization.interface';

export function useCreateOrganization() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: (dto: ICreateOrganizationDto) => organizationApi.create(dto),
        onSuccess: (data) => {
            setAccessToken(data.accessToken);
            queryClient.clear();
            toast.success(t('organization.toasts.createdSuccess'));
            window.location.replace('/');
        },
        onError: () => {
            toast.error(t('organization.toasts.createdError'));
        },
    });
}
